import { sendUtagEvent } from '../../core/analytics/utag_events'
import Modal from '../../shared/modal/modal'
import { stopAllVideosInContainer, transformToLiteYoutube } from '../../utils/control_youtube_video'
import on from '../../utils/events_delegation'

import { initializeUtagEvents, sendUtagEventSustainability } from './wave_of_change.analytics'

const BLOCK_SELECTOR = '.js-wave-of-change'
const MODAL_OPEN_SELECTOR = 'data-woc-micromodal-trigger'

/**
 * Función que activa y elimina, cuando corresponda, la clase "active" de un elemento recibido
 * Recibe el elemento que deberá ser activado y la clase identificativa que tiene
 * @param {*} $element Elemento clicado
 * @param {*} klass Clase recibida
 */
function addOrRemoveActiveClassFromElementClicked(element, klass) {
  const parent = element.parentNode
  const children = parent.querySelectorAll(klass)
  children.forEach(child => {
    if (element === child) {
      element.classList.add('active')
    } else {
      child.classList.remove('active')
    }
  })
}

/**
 * Activa la pestaña y el contenido asociado al elemento que ha sido clicado
 * @param {*} tab Tab a activar
 */
function activeTabAndContentAssociated(tab) {
  // Activo la pestaña del item que he seleccionado
  const currentTabElement = document.querySelector(`#tab-${tab}`)
  addOrRemoveActiveClassFromElementClicked(currentTabElement, '.content-tab')
  // Activo el contenido asociado al item seleccionado
  const currentContentElement = document.querySelector(`#content-${tab}`)
  addOrRemoveActiveClassFromElementClicked(currentContentElement, '.tab-wrapper')
}

function get_act(name) {
  let act = ''
  if (name.includes('bottle')) {
    act = 'circular economy'
  } else if (name.includes('pesca')) {
    act = 'responsible fishing'
  } else if (name.includes('salud_costera')) {
    act = 'coastal health'
  }
  return act
}

export function init() {
  const blocks = document.querySelectorAll(BLOCK_SELECTOR)
  const isFhiPage = document.querySelector('html').dataset.fhiTest !== undefined

  if (!blocks.length) return

  blocks.forEach(block => {
    const modalTriggers = block.querySelectorAll(`[${MODAL_OPEN_SELECTOR}]`)

    if (!modalTriggers.length) return

    modalTriggers.forEach(modalTrigger => {
      const modalId = modalTrigger.dataset.wocMicromodalTrigger

      modalTrigger.addEventListener('click', event => {
        const el = event.target.classList.contains('open-link-woc-item')
          ? event.target
          : event.target.closest('.open-link-woc-item')
        const tab = el.dataset.tab

        sendUtagEventSustainability(get_act(el.childNodes[1].className), 'body')

        Modal.show(modalId, {
          onShow: () => {
            ScrollLock.on()
            activeTabAndContentAssociated(tab)
            IB.lazyImg.loadAllImagesSelector($('.fancybox-info-woc'))
          },
          onClose: modal => {
            ScrollLock.off()
            setTimeout(() => {
              stopAllVideosInContainer(modal, true)
            }, 200)
          },
          awaitCloseAnimation: true,
        })
      })
    })
  })

  on({
    eventName: 'click',
    selector: '.fancybox-info-woc .play-video',
    handler: event => {
      const el = event.target.classList.contains('play-video') ? event.target : event.target.closest('.play-video')

      const block_video = el.closest('.video')

      if (block_video.querySelector('iframe') || block_video.querySelector('lite-youtube')) {
        return
      }

      const img_video = block_video.querySelector('picture')

      const videoId = el.getAttribute('data-video')
      const videoTitle = el.getAttribute('data-title')

      if (!videoId) {
        console.error('No se encontró ID de video')
        return
      }

      const videoContainer = document.createElement('div')
      videoContainer.classList.add('video-content', 'js-video-youtube')
      videoContainer.dataset.videoId = videoId

      block_video.insertBefore(videoContainer, block_video.firstChild)

      if (img_video) {
        videoContainer.style.width = `${img_video.offsetWidth}px`
        videoContainer.style.height = `${img_video.offsetHeight}px`
      }

      transformToLiteYoutube(videoContainer)

      const layer = block_video.querySelector('.layer')
      if (layer) layer.style.display = 'none'
      if (img_video) img_video.style.display = 'none'

      block_video.classList.remove('bg-video')

      const liteYoutube = videoContainer.querySelector('lite-youtube')
      liteYoutube.classList.add('lyt-activated')
      const shadowRoot = liteYoutube.shadowRoot
      if (liteYoutube) {
        const playButton = shadowRoot.getElementById('playButton')
        if (playButton) {
          playButton.click()
        }
      }

      block_video.classList.remove('bg-video')
    },
  })

  on({
    eventName: 'click',
    selector: '.fancybox-info-woc .content-tab',
    handler: event => {
      const el = event.target.classList.contains('content-tab') ? event.target : event.target.closest('.content-tab')

      const category = 'wave of change module'
      const action = get_act(el.childNodes[1].className)
      const label = 'popup'
      const fhiPageType = document.querySelector('html').dataset.fhiTest

      if (!isFhiPage) {
        sendUtagEvent({ data: { event_cat: category, event_act: action, event_lbl: label } })
      } else {
        sendUtagEvent({
          data: { event_cat: category, event_act: action, event_lbl: label, page_variation: fhiPageType },
        })
      }

      /*
       * Si hago clic en una nueva pestaña, la tendré que poner a activa, así como desactivar
       * la pestaña que anteriormente estaba activa
       */
      sendUtagEventSustainability(get_act(el.childNodes[1].className), 'popup')

      const tab = el.dataset.tab
      stopAllVideosInContainer(document, true)
      activeTabAndContentAssociated(tab)
    },
  })
  initializeUtagEvents()
}
